import { createAsyncThunk } from '@reduxjs/toolkit';
import { GUEST_LINK_EROR_MESSAGE } from '~/helpers/constants';
import { selectApiBaseUrl } from '~/store/env/selectors';

export default createAsyncThunk('joinBroadcast/getBroadcast', async (broadcastHash, { getState }) => {
  const options = {
    method: 'POST',
    headers: {
      authorization: sessionStorage.getItem('authToken'),
      'Content-Type': 'application/json',
      'x-api-version': '2.0',
    },
  };
  const apiBaseUrl = selectApiBaseUrl(getState());
  const response = await fetch(`${apiBaseUrl}/broadcast/join/${broadcastHash}`, options);

  const handledErrors = {
    403: GUEST_LINK_EROR_MESSAGE.FORBIDDEN,
    404: GUEST_LINK_EROR_MESSAGE.NOT_FOUND,
  };

  const errorMessage = handledErrors[response?.status];

  if (!response.ok) throw new Error(errorMessage ?? GUEST_LINK_EROR_MESSAGE.DEFAULT);
  const data = await response.json();

  return data;
});
